export default class C5UsuarioEnderecoModel {
  public ClientID?: number = 0;
  public Description?: string = "";
  public CompleteAddress?: string = "";
  public StreetAddress: string = "";
  public Address?: string = "";
  public Number?: number = 0;
  public Complement?: string = "";
  public Neighborhood: string = "";
  public CityID: number = 0;
  public State: string = "SP";
  public CityAndState?: string = "";
  public ZipCode: string = "";
  public ClientAddressID?: number = 0;

  public static toModel(obj: any): C5UsuarioEnderecoModel {
    return {
      StreetAddress: obj.StreetAddress,
      Neighborhood: obj.Neighborhood,
      State: obj.State,
      CityID: obj.CityID,
      City: obj.City,
      ZipCode: obj.ZipCode,
      ClientAddressID: obj.ClientAddressID,
    } as C5UsuarioEnderecoModel;
  }
}
